import { render, staticRenderFns } from "./wxOfficial.vue?vue&type=template&id=7e32742a&scoped=true"
import script from "./wxOfficial.vue?vue&type=script&lang=js"
export * from "./wxOfficial.vue?vue&type=script&lang=js"
import style0 from "./wxOfficial.vue?vue&type=style&index=0&id=7e32742a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e32742a",
  null
  
)

export default component.exports